import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BxApiErrorService } from './bx-api-error.service';

@Injectable({ providedIn: 'root' })
export class BxApiErrorInterceptorService implements HttpInterceptor {
    constructor(private bxApiErrorService: BxApiErrorService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.bxApiErrorService.handle(error);
                return throwError(error);
            })
        );
    }
}
